import React, { useEffect, useState } from "react";
import UniqueUserTable from "./UniqueUserTable";
import { UniqueUser  } from "../../types";
import { fetchAllUsers, updateUniqueUsers } from "../../services/api";
import { useSidebar } from '../../contexts/SidebarContext';
import { Button } from 'primereact/button';
import { useTranslation } from '../../locales/useTranslation';
import { useAuthGuard } from '../../hooks/useAuthGuard';
import eventBus from '../../eventBus';
import { useNewGui } from '../../hooks/useNewGui';
import PageHeader from '../shared/PageHeader';



const UniqueUserPage : React.FC = () => {

    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const useNew = useNewGui();
    const [users, setUsers] = useState<UniqueUser[]>([]);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const t = useTranslation();
    const { isAuthenticated, authValidated } = useAuthGuard();

  useEffect(() => {
    if (isAuthenticated && authValidated) {
      const loadUsers = async () => {
        try {
          const data = await fetchAllUsers();
          console.log("Fetched unique users:", data);
          setUsers(data);
        } catch (error) {
          console.error("Error fetching unique users:", error);
        } finally {
          setLoading(false);
        }
      };

      loadUsers();
    }
  }, [isAuthenticated, authValidated]);

  const handleUpdateUniqueUsers = async () => {
    setUpdating(true);
    try {
      // Use proper API service with authentication
      await updateUniqueUsers();
      console.log('Unique users update completed successfully');

      // Refresh the users list
      const data = await fetchAllUsers();
      setUsers(data);

      // Show success message
      eventBus.emit('show-toast', {
        summary: 'Success',
        message: 'Unique users information updated successfully',
        severity: 'success'
      });

    } catch (error) {
      console.error('Error updating unique users:', error);
      eventBus.emit('show-toast', {
        summary: 'Update Failed',
        message: 'Failed to update unique users information',
        severity: 'error'
      });
    } finally {
      setUpdating(false);
    }
  };
  return (
    <div
        className={`flex-1 p-6 transition-all duration-300 ${
            useNew ? 'bg-surface-app font-plex' : 'bg-white'
        } ${isSidebarOpen ? 'ml-64' : 'ml-20'}`}
    >
    <div className="mb-4">
      {useNew ? (
        <PageHeader title="Unique Users" purpose="Find a person across every account and license they hold." />
      ) : (
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">{t.manageUsersPageTitle}</h1>
        </div>
      )}
    </div>
    {loading
      ? <p className={useNew ? 'text-ink-secondary' : undefined}>Loading Unique Users data...</p>
      : <UniqueUserTable uniqueUsers={users} />}
  </div>
  );
};

export default UniqueUserPage
